import './scripts/global';
import './scripts/blocks/component-component-media';
import './scripts/blocks/component-tab-container';
import './scripts/blocks/component-simple-cards';
import './scripts/blocks/component-accordion';
import './scripts/blocks/component-video';
import './scripts/blocks/component-embed';
import './scripts/blocks/block-container';
import './scripts/layout/footer';
import './scripts/layout/filters';
import './scripts/layout/site-menu';

import './scripts/blocks/component-swiper-slide';